import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ProtocolQTestAttachment, ProtocolAttachmentFilter } from './protocol';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';

import { ProtocolQTestsService } from '../services/protocol-qtests.service';

export class ProtocolQTestAttachmentDataSource implements DataSource<ProtocolQTestAttachment> {

    private attachmentSubject = new BehaviorSubject<ProtocolQTestAttachment[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ProtocolQTestsService) { }

    connect(_collectionViewer: CollectionViewer): Observable<ProtocolQTestAttachment[]> {
        return this.attachmentSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.attachmentSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadProtocolAttachment(id: number, filter = new ProtocolAttachmentFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAttachments(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.attachmentSubject.next(data.content as ProtocolQTestAttachment[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.attachmentSubject.next(data as ProtocolQTestAttachment[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.attachmentSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
